import axios from 'axios';

export const getCargoTypes = () => {
    return axios.get(window.Configuration['API_URL'] + '/api/CargoType/GetAllCargoTypes')
}